
import { createStyles } from "../../lib/helpers"


const styles = createStyles({
    header: {
        position: "fixed",
        width: "100vw",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        fontSize: "calc(10px + 2vmin)",
        height: "60px",
        paddingLeft: "32px",
        paddingRight: "32px",
        borderBottom: "1px solid var(--git-black-half)",
        boxShadow: "0px 2px 10px var(--git-black-half)",
        backdropFilter: "blur(8px)",
        zIndex: 1000,
    }
})

export default styles